import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Nullable } from '@src/types/utils';

import { ChatModel, ChatPermissionsModel } from '../types';

@Component({
  selector: 'chat-details',
  templateUrl: './chat-details.component.html',
  styleUrls: ['./chat-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class ChatDetailsComponent {
  @Input() chat?: ChatModel;
  @Input() permissions?: Nullable<ChatPermissionsModel>;
  @Output() close = new EventEmitter<void>();

  onClose() {
    this.close.emit();
  }
}
